var styleDataHash = "249ab445";
const injectCss = () => {
  var css = `.zSZ12{align-items:center;background:transparent;border:none;cursor:pointer;display:flex;min-height:48px;padding:0;position:relative;width:max-content}.zSZ12:hover{opacity:.5}.C88bq{display:flex;padding-inline-start:10px}.C88bq,.C88bq svg{color:var(--ricos-action-color,#116dff)}.C88bq svg{fill:var(--ricos-action-color,#116dff)}.xI3eT{cursor:pointer;font-size:16px;font-stretch:normal;font-style:normal;font-weight:400;letter-spacing:normal;padding-inline-start:8px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var new_pair_button_rtlignore_default = {
  "new_pair_container": "zSZ12",
  "new_pair_button": "C88bq",
  "new_pair_label": "xI3eT"
};
export {
  new_pair_button_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=new-pair-button.rtlignore-scss.js.map
